module.exports = __webpack_public_path__ + "img/neg-other.01011163.png";